import React, { useEffect, useState } from 'react';
import styles from './FileCard.module.css';
import MoreButton from '../../Molecules/Custom/CardMoreButton';
import exportICon from '../../../assets/Imagess/exportIcon.svg';
import deleteicon from '../../../assets/Imagess/deleteicon.svg';
import moreicon from '../../../assets/Imagess/more-dotes.svg';

import IDImage from '../../../assets/Imagess/IDImage.svg';
import PassportImage from '../../../assets/Imagess/PassportImage.svg';
import FamilyImage from '../../../assets/Imagess/FamilyImage.svg';
import CVImage from '../../../assets/Imagess/CVImage.svg';
import InfoButton from '../InfoButton/InfoButton';

/**
 * The file's extension, upper-cased — `PDF`, `DOCX`.
 *
 * Returns '' when there is nothing after a dot to read, so the caller can fall
 * back rather than render a stray full stop.
 */
const extensionOf = (name) => {
  const match = /\.([a-z0-9]{1,5})$/i.exec(String(name || '').trim());
  return match ? match[1].toUpperCase() : '';
};

const ReseachFile = ({
  file,
  id,
  type,
  setSelectedFile,
  setShowAttachModal,
  handleDeleteFile,
  base64String,
  mimeType,
  fileName,
  url,
  /**
   * Fetches a FRESH url for this file, awaited at the moment of the click.
   * Optional: without it the `url` prop is used as-is.
   */
  resolveUrl,
  onError,
}) => {
  /**
   * Two sources, because the research API changed delivery mid-flight.
   *
   * It used to return each file as base64 on the record. It now returns a URL,
   * and no content at all — so `base64String` is `undefined` on every new
   * record, `.replace()` on undefined throws, the catch below logs to a
   * console nobody is watching, and the operator sees a Download menu item
   * that does nothing.
   *
   * ⚠ AND THE URL EXPIRES. As of 2026-10-19 the documents live in private
   * storage and the address handed to an admin is signed and valid for
   * FIFTEEN MINUTES. The detail screen fetches it when it opens, which is not
   * when the operator clicks — open a record, get called away, come back
   * twenty minutes later, and the link is dead. Blob storage answers an
   * expired signature with an XML error document, which `<a download>` would
   * happily save to disk as the PDF the operator asked for.
   *
   * So the url is re-fetched at the moment of the click when a resolver is
   * given, and the one captured at render is only the fallback. One extra
   * request per download, against a class of failure that is invisible until
   * somebody opens the file.
   */
  const handleDownload = async () => {
    let href = url;

    if (resolveUrl) {
      try {
        href = (await resolveUrl()) || url;
      } catch (error) {
        // The stale url is still worth trying: it may be within the window.
        href = url;
      }
    }

    if (href) {
      const link = document.createElement('a');
      link.href = href;
      link.download = fileName || 'downloaded-file';
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    }

    if (!base64String) {
      onError?.('تعذر الحصول على رابط الملف. يرجى تحديث الصفحة والمحاولة.');
      return;
    }

    try {
      const cleanedBase64 = base64String.replace(/\s+/g, '');

      const byteCharacters = atob(cleanedBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: mimeType });

      console.log('Blob created:', blob);

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = fileName || 'downloaded-file';

      document.body.appendChild(link);
      link.click();

      URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  const menuItems = [
    {
      label: 'تحميل',
      icon: exportICon,
      onClick: handleDownload,
    },
  ];

  return (
    <>
      <div className={styles['document']}>
        <img
          alt="PHo"
          src={
            type === 'Emirates Id'
              ? IDImage
              : type === 'CV'
              ? CVImage
              : type === 'Family Book'
              ? FamilyImage
              : PassportImage
          }
          className={styles['document-img']}
        />
        <div>
          <div className={styles['document-cont']}>
            {/* THE TYPE LEADS, not the filename.
                Uploads are stored under a generated GUID, so the heading read
                «..23a9061e-70cc-4» — fifteen characters of an identifier,
                truncated — while «وثيقة البحث», the only part that means
                anything to an operator, was the subtitle. Swapped, and the
                extension is kept because "is it a PDF or a Word file" is the
                one useful thing the filename still carries. */}
            <h4 title={fileName}>{type || fileName}</h4>
            <InfoButton
              icon={moreicon}
              className={styles['more-info']}
              data={menuItems}
              left="0"
            />
          </div>
          <p>{extensionOf(fileName) || fileName}</p>
        </div>
      </div>
    </>
  );
};

export default ReseachFile;
